import { useState } from "react"
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ActionMenu, { Action } from "../../../../components/ui/materialui/actionMenu";
import ConfirmationModal from "../../../../components/ui/materialui/confirmationModal";
import { RowCorreccionMonetaria } from "../models/rowCorreccionMonetaria";
import { usePermissions } from "../../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../../utils/enums";

interface IProps {
    row: RowCorreccionMonetaria,
    onUpdate: (row: RowCorreccionMonetaria) => void,
    onDelete: (row: RowCorreccionMonetaria) => void
}

export const AccionesCorreccionMonetaria: React.FC<IProps> = ({ row, onUpdate, onDelete }) => {
    const { hasPermission } = usePermissions();
    const puedeEditar = hasPermission(TipoFuncionalidad.Maestros_editar);
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    })

    const handleEliminarClick = () => {
        setModalConfirmacion({
            show: true,
            title: "Eliminar corrección monetaria",
            message: "¿Está seguro de querer eliminar la corrección monetaria?",
            metodo: () => {
                onDelete(row);
            },
        })
    }

    const handleUpdateClick = () => onUpdate(row);

    const actions: Action[] = [];

    if (puedeEditar) {
        actions.push({ label: "Editar", icon: <EditIcon fontSize="small" />, onClick: handleUpdateClick });
        actions.push({ label: "Eliminar", icon: <DeleteIcon fontSize="small" />, onClick: handleEliminarClick });
    }
    return (
        <>
            <ActionMenu actions={actions} />
            <ConfirmationModal
                onHide={() => setModalConfirmacion({ ...modalConfirmacion, show: false })}
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />
        </>
    );
}